import { NgModule, Injector, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { createCustomElement } from '@angular/elements';
import { MaterialGlobalModule } from 'src/app/shared/modules/material-global.module';
import { NgxSliderModule } from '@angular-slider/ngx-slider';
import { SharedComponentsModule } from '../shared/shared-components.module';
import { IndicatorIconsComponent } from './plan-details/indicator-icons/indicator-icons.component';
import { ReducersRegistryModule } from 'src/app/shared/modules/reducers-registry.module';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { FormWrappersModule } from '../form-wrappers/form-wrappers.module';

// Plan Components
import { PlanCardComponent } from './plan-card/plan-card.component';
import { PlanPriceSliderComponent } from './plan-price-slider/plan-price-slider.component';

// Plan Summary Components
import { PlanSummaryListComponent } from './plan-summary-list/plan-summary-list.component';


// Plan Details Components
import { PlanDetailsComponent } from './plan-details/plan-details.component';
import { PlanDetailsHeaderComponent } from './plan-details/plan-details-header/plan-details-header.component';
import { ComparePlanCardComponent } from './plan-details/compare-plans-header/compare-plan-card/compare-plan-card.component';
import { ComparePlansHeaderComponent } from './plan-details/compare-plans-header/compare-plans-header.component';
import { BenefitGridComponent } from './plan-details/benefit-grid/benefit-grid.component';
import { BenefitGroupComponent } from './plan-details/benefit-grid/benefit-group/benefit-group.component';
import { PrescriptionDrugTiersComponent } from './plan-details/benefit-grid/benefit-group/benefit-tables/prescription-drug-tiers/prescription-drug-tiers.component';
import { PlanUsageComponent } from './recommended-plan-summary/plan-usage/plan-usage.component';
import { PlanAndDrxTabsComponent } from './plan-and-drx-tabs/plan-and-drx-tabs.component';
import { MedicalInformationModule } from '../medical-information/medical-information.module';
import { VendorRedirectModalComponent } from './plan-card/vendor-redirect-modal/vendor-redirect-modal.component';
import { PlanDocumentsComponent } from './plan-details/benefit-grid/benefit-group/benefit-tables/plan-documents/plan-documents.component';
import { YearSelectionComponent } from './year-selection/year-selection.component';
import { BenefitCategoryComponent } from './plan-details/benefit-grid/benefit-category/benefit-category.component';
import { MatIconModule } from '@angular/material/icon';
import { ProductTypeBannerComponent } from './product-type-banner/product-type-banner.component';
import { PlanSorterPipe } from './pipes/plan-sorter.pipe';
import { PricePipe } from './pipes/price.pipe';
import { ActiveProductGroupPipe } from './pipes/active-product-group.pipe';
import { PlanFilterComponent } from './plan-filter/plan-filter.component';
import { PlanAttributeFilterPipe } from './plan-filter/pipes/plan-filter.pipe';
import { PlanDataSorterPipe } from './plan-filter/pipes/plan-data-sorter.pipe';
import { PlanSortByAttributeComponent } from './plan-sort-by-attribute/plan-sort-by-attribute.component';
import { PlanSummaryListPaginatorComponent } from './plan-summary-list-paginator/plan-summary-list-paginator.component';
import { PlanSummaryListPaginatorPipe } from './plan-summary-list-paginator/pipes/plan-summary-list-paginator.pipe';
import { IndividualDrugCoverageComponent } from './plan-card/individual-drug-coverage/individual-drug-coverage.component';
import { MedicalBenefitComponent } from './plan-details/benefit-grid/benefit-group/benefit-tables/medical-benefit/medical-benefit.component';
import { MedicalDetailsModalComponent } from './plan-card/medical-details-modal/medical-details-modal.component';
import { AdditionalPlanLinksComponent } from './plan-details/additional-plan-links/additional-plan-links.component';
import { AdditionalPlanLinksStorageComponent } from './plan-details/additional-plan-links/additional-plan-links-storage/additional-plan-links-storage.component';
import { PremiumDetailsIndividualComponent } from './premium-details-individual/premium-details-individual.component';
import { AdvancePremiumTaxCreditSliderComponent } from './advance-premium-tax-credit-slider/advance-premium-tax-credit-slider.component';
import { PlanChangeContentComponent } from './plan-change-content/plan-change-content.component';
import { PlanDetailsDocumentsComponent } from './plan-details-documents/plan-details-documents.component';
import { ComparePlansHighlightComponent } from './plan-details/compare-plans-highlight/compare-plans-highlight.component';
import { PlanCardCoverageDetailsComponent } from './plan-card/plan-card-coverage-details/plan-card-coverage-details.component';
import { SeniorDrugCoverageComponent } from './plan-card/senior-drug-coverage/senior-drug-coverage.component';
import { SaveQuoteButtonComponent } from '../producer/save-quote-button/save-quote-button.component';
import { StateModuleReadyService } from '@ptl/state';
@NgModule({
  declarations: [
    PlanCardComponent,
    PlanPriceSliderComponent,
    PlanDetailsComponent,
    BenefitGridComponent,
    BenefitGroupComponent,
    PlanDetailsHeaderComponent,
    ComparePlansHeaderComponent,
    ComparePlanCardComponent,
    IndicatorIconsComponent,
    PrescriptionDrugTiersComponent,
    PlanUsageComponent,
    PlanAndDrxTabsComponent,
    VendorRedirectModalComponent,
    MedicalDetailsModalComponent,
    PlanDocumentsComponent,
    YearSelectionComponent,
    PlanSummaryListComponent,
    BenefitCategoryComponent,
    ProductTypeBannerComponent,
    PlanFilterComponent,
    PlanSortByAttributeComponent,
    PlanSummaryListPaginatorComponent,
    PremiumDetailsIndividualComponent,
    IndividualDrugCoverageComponent,
    MedicalBenefitComponent,
    AdditionalPlanLinksComponent,
    AdditionalPlanLinksStorageComponent,
    AdvancePremiumTaxCreditSliderComponent,
    PlanChangeContentComponent,
    PlanDetailsDocumentsComponent,
    ComparePlansHighlightComponent,
    // Pipes
    PlanSorterPipe,
    PricePipe,
    ActiveProductGroupPipe,
    PlanAttributeFilterPipe,
    PlanDataSorterPipe,
    PlanSummaryListPaginatorPipe,
    PlanCardCoverageDetailsComponent,
    SeniorDrugCoverageComponent,
    SaveQuoteButtonComponent
  ],
  imports: [
    CommonModule,
    MaterialGlobalModule,
    MatIconModule,
    ReactiveFormsModule,
    NgxSliderModule,
    SharedComponentsModule,
    ReducersRegistryModule,
    MedicalInformationModule,
    FormsModule,
    FormWrappersModule
  ],
  exports: [
    YearSelectionComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  providers: [PlanAttributeFilterPipe]
})

export class PlanSelectionModule {
  constructor(
    private injector: Injector,
    private stateModuleReadyService: StateModuleReadyService
  ) {
    // console.log("PlanSelectionModule - constructor");
    this.stateModuleReadyService.ready$.subscribe((isReady: boolean) => {
      if (isReady) {
        this.createElementIfDoesNotExist('sxe-plan-and-drx-tabs', PlanAndDrxTabsComponent);
        this.createElementIfDoesNotExist('sxe-plan-summary-list', PlanSummaryListComponent);

        this.createElementIfDoesNotExist('sxe-plan-details', PlanDetailsComponent);

        this.createElementIfDoesNotExist('sxe-product-type-banner', ProductTypeBannerComponent);
        this.createElementIfDoesNotExist('sxe-plan-usage', PlanUsageComponent);
        this.createElementIfDoesNotExist('sxe-year-selection', YearSelectionComponent);

        this.createElementIfDoesNotExist('sxe-plan-filter', PlanFilterComponent);
        this.createElementIfDoesNotExist('sxe-plan-sort-by-attribute', PlanSortByAttributeComponent);
        this.createElementIfDoesNotExist('sxe-plan-summary-list-paginator', PlanSummaryListPaginatorComponent);
        this.createElementIfDoesNotExist('sxe-plan-change-content', PlanChangeContentComponent);
        this.createElementIfDoesNotExist('sxe-additional-plan-links-storage', AdditionalPlanLinksStorageComponent);
        this.createElementIfDoesNotExist('sxe-save-quote-button', SaveQuoteButtonComponent);
        }
    });
  }

  /** Adding these checks in, as during debugging, sometimes the error of previous definition would be thrown */
  createElementIfDoesNotExist(elementName: string, elementComponent: any) {
    if (!customElements.get(elementName)) {
      const customElement = createCustomElement(elementComponent, {
        injector: this.injector
      });
      customElements.define(elementName, customElement);
    }
  }
  ngDoBootstrap() { }
}
